import { render, staticRenderFns } from "./TraxNotificationRead.vue?vue&type=template&id=29c90952"
import script from "./TraxNotificationRead.vue?vue&type=script&lang=js"
export * from "./TraxNotificationRead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports